import { ele, CablesConstants } from "cables-shared-client";
import api from "../../api.js";
import web from "../../index.js";

export default class PageAdminActivity
{
    constructor(_targetElement)
    {
        this.updateActivity(true);
        this.updateProjects();
    }

    updateActivity(includeInactive = false)
    {
        let apiUrl = "admin/activity";
        if (includeInactive) apiUrl += "?inactive=true";
        api.get(apiUrl, (res) =>
        {
            const statsEle = ele.byId("stats");
            const activityEle = ele.byId("activity");
            const users = res.users;
            const feed = res.feed;
            let count24h = 0;
            const userTable = { "cols": [], "rows": [] };
            users.forEach((user) =>
            {
                let in24h = user.secondsAgo <= 24 * 60 * 60;
                if (in24h)count24h++;

                let location = user.ip || "";
                if (user.geo)location = user.geo.country + " - " + user.geo.city;
                const row = [
                    "<a href=\"/user/" + user.username + "\">" + user.username + "</a>",
                    user.ago,
                    user.lastUrl,
                    "<a href=\"https://ipinfo.io/" + user.ip + "\">" + location + "</a>"
                ];
                userTable.rows.push(row);
            });
            web.setHandleBarHtml("table", userTable, activityEle);
            const feedTable = { "cols": [], "rows": [] };
            let lastEntry = { "initiator": { }, "title": null, "description": null };
            feed.forEach((feedEntry) =>
            {
                if (lastEntry.initiator.username !== feedEntry.initiator.username && lastEntry.title !== feedEntry.title && lastEntry.description !== feedEntry.description)
                {
                    const m = moment(feedEntry.updated);
                    let displayDate = m.fromNow();
                    if (m.isBefore(moment().subtract(7, "days"))) displayDate = moment(feedEntry.updated).format(CablesConstants.DATE_FORMAT_RELATIVEDATE_FULL);

                    const row = [
                        "<a href=\"/user/" + feedEntry.initiator.username + "\">" + feedEntry.initiator.username + "</a>",
                        displayDate,
                        feedEntry.title,
                        feedEntry.description,
                        "<a href=\"" + feedEntry.referenceUrl + "\">link</a>"
                    ];
                    feedTable.rows.push(row);
                }
                lastEntry = feedEntry;
            });
            web.setHandleBarHtml("table", feedTable, ele.byId("activityFeed"));
            ele.byId("activitystats").innerHTML = "<h2 style=\"margin-top: 0;\">" + count24h + "</h2>users in 24h";
            if (res.inactive)
            {
                const inactiveEle = ele.byId("inactivitystats");
                let inactiveHtml = "";
                if (res.inactive.unconfirmed) inactiveHtml += "<div class=\"cute-3-tablet\"><h2 style=\"margin-top: 0; color: var(--middle-grey);\">" + res.inactive.unconfirmed + "</h2>unconfirmed emails</div>";
                if (res.inactive.neverLoggedIn) inactiveHtml += "<div class=\"cute-3-tablet\"><h2 style=\"margin-top: 0; color: var(--middle-grey);\">" + res.inactive.neverLoggedIn + "</h2>never logged in</div>";
                if (res.inactive.longTimeNoLogin) inactiveHtml += "<div class=\"cute-3-tablet\"><h2 style=\"margin-top: 0; color: var(--middle-grey);\">" + res.inactive.longTimeNoLogin + "</h2>no login in " + res.inactive.yearsToInactive + " years</div>";
                inactiveEle.innerHTML = inactiveHtml;
            }
            web.tables.initTables(statsEle.querySelectorAll("table.sortable"));
            setTimeout(this.updateActivity.bind(this), 15000);
        });
    }

    updateProjects()
    {
        api.get("admin/latest", (res) =>
        {
            let html = "";
            for (let i = 0; i < res.length; i++)
            {
                html += web.getHandleBarHtml("project_small", res[i]);
            }

            ele.byId("latestpatches").innerHTML = "<div class=\"row\">" + html + "</div>";
            setTimeout(this.updateActivity.bind(this), 30000);
        });
    }
}
